<div class="row">
    <!-- <div class="col-12">
        <app-billingmenustrip></app-billingmenustrip>
    </div> -->
    <div class="col-lg-12">
        <div class="col-lg-12">
            <div class="card">
                <!-- Card header -->
                <div class="card-header border-0">
                  <div class="row">
                    <h3 class="mb-0">Bills</h3>                   
                  </div>
                </div>
                <!-- Light table -->
                <div class="table-responsive">
                  <table class="table align-items-center table-flush table-hover">
                    <thead class="thead-light">
                      <tr>   
                       <th> Title </th>                 
                       <th> Amount</th>
                       <th> Status </th>
                       <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr  *ngFor="let bill of bills"  >
                          <td> <a routerLink="/billing/billdetails" [queryParams]="{bid:bill.invoiceID}" > {{bill.title}}</a></td>
                          <td><b>₦{{this.utilService.numberWithCommas(bill.total <= 0 ? 0 : bill.total)}}</b></td>
                          <!-- <td>22000</td> -->
                          <td>
                            <span *ngIf="!bill.ready; else invoiceReady"><i class="mr-3 fa fa-hourglass-half"></i> Not Ready</span>
                            <ng-template #invoiceReady>
                                <span *ngIf="bill.paid"><i class="mr-3 fa fa-check-circle text-green"></i> Paid  </span>
                                <span *ngIf="!bill.paid"><i class="mr-3 fa fa-times-circle text-red"></i> Unpaid</span>      
                            </ng-template>
                            <!-- <span *ngIf="bill.paid"><i class="mr-3 fa fa-check-circle text-green"></i> Paid </span>
                            <span *ngIf="!bill.paid"><i class="mr-3 fa fa-times-circle text-red"></i> Unpaid </span> -->
                          </td>
                          <td><button class="btn" routerLink="/billing/billdetails" [queryParams]="{bid:bill.invoiceID}" [disabled]="!bill.ready || bill.paid">Pay Now</button></td>
                      </tr>     
                                  
                    </tbody>
                  </table>
                </div>
              </div>
        </div>
    </div>
</div>
